import React from 'react'
import styled from 'styled-components'

interface Props {
  isDisabled?: boolean
  showDialogs: boolean
  onChange: () => void
}

export const FooterContent: React.FC<Props> = ({ isDisabled, showDialogs, onChange }) => {
  return (
    <Wrapper data-test={'e2e-footer'}>
      <InputStyled checked={showDialogs} disabled={isDisabled} onChange={onChange} />{' '}
      <Label>Show dialogs</Label>
    </Wrapper>
  )
}

const Label = styled.div`
  color: #7f8fa4;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  position: relative;
  display: inline-block;
  margin: 3px 0px 0px 12px;
  font-family: neue-haas-unica, sans-serif;
`

const Wrapper = styled.div`
  flex: 1;
  margin: 10px;
  display: flex;
  flex-direction: row;
`

const InputStyled = styled.input.attrs({ type: 'checkbox' })`
  width: 16px;
  height: 16px;
  border-radius: 4px;
  margin-right: 14px;
  position: relative;
  background: #1991eb;
  display: inline-block;
`
